export const focusAreaText = [{
    key: 'text_data',
    type: 'textarea',
    isHtmlType:true,
    value: '',
    valid: false,
    elementConfig: {
        name: 'text_data',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

}]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/FocusAreaText/formData.js